import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import AdminCards from "./pages/AdminCards";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminProtectedRoute from "./pages/AdminProtectedRoute";
import AdminMembers from "./pages/AdminMembers";

import "./App.css";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AdminLogin />} />

        <Route
          path="/dashboard"
          element={
            <AdminProtectedRoute>
              <AdminDashboard />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/cards"
          element={
            <AdminProtectedRoute>
              <AdminCards />
            </AdminProtectedRoute>
          }
        />
        <Route
          path="/members"
          element={
            <AdminProtectedRoute>
              <AdminMembers />
            </AdminProtectedRoute>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
